export enum WaitingQueueStatus {
  FAIL = "FAIL",
  NONE = "NONE",
  WAITING = "QUEUE",
  ACTIVE = "CODE",
}

export type WaitingQueueInfo = {
  status: WaitingQueueStatus;
  message: string;
  position?: number; // 현재 내 순번
  waitingCount?: number; // 전체 대기열 인원
  wsEligible?: boolean; // 소켓 사용 가능 여부
};

export type RegisterWaitingQueueRequest = void;
export type RegisterWaitingQueueResponse = WaitingQueueInfo;

export type FetchQueueStatusRequest = void;
export type FetchQueueStatusResponse = WaitingQueueInfo;

export type QueueEnteringResponse = {
  ok: boolean;
};
